const colorFunc = (hex, delta = 12) => {
  if (!hex || !hex.startsWith('#')) return hex || '#000000';
  const hexClean = hex.replace('#', '');
  const bigint = parseInt(hexClean.length === 3 ? hexClean.split('').map(c => c + c).join('') : hexClean, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // rgb -> hsl
  const rNorm = r / 255, gNorm = g / 255, bNorm = b / 255;
  const max = Math.max(rNorm, gNorm, bNorm), min = Math.min(rNorm, gNorm, bNorm);
  let h = 0, s = 0;
  let l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case rNorm: h = (gNorm - bNorm) / d + (gNorm < bNorm ? 6 : 0); break;
      case gNorm: h = (bNorm - rNorm) / d + 2; break;
      case bNorm: h = (rNorm - gNorm) / d + 4; break;
    }
    h /= 6;
  }

  // adjust lightness (convert to percent, apply delta, clamp)
  l = Math.max(0, Math.min(1, l + (delta / 100)));

  // hsl -> rgb
  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };

  let rNew, gNew, bNew;
  if (s === 0) {
    rNew = gNew = bNew = l;
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    rNew = hue2rgb(p, q, h + 1 / 3);
    gNew = hue2rgb(p, q, h);
    bNew = hue2rgb(p, q, h - 1 / 3);
  }

  const toHex = (v) => {
    const val = Math.round(v * 255);
    return val.toString(16).padStart(2, '0');
  };
  return `#${toHex(rNew)}${toHex(gNew)}${toHex(bNew)}`;
};

module.exports = colorFunc